import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import useLogin from "../../../services/useLogin";
import { ButtonLoader1 } from "../../../components/shared/ButtonLoaders";
import { SocialLogin } from "./components/SocialLogin";
import { PiEyeSlash, PiEyeLight } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";

const validationSchema = Yup.object({
  email: Yup.string().required("Email is required").max(100, "Limit exceeded"),
  password: Yup.string()
    .required("Password is required")
    .max(100, "Limit exceeded"),
});

function Signin() {
  const [password, setPassword] = useState(false);
  const { Login, loading } = useLogin();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const next = searchParams.get("next") || "/";

  const initialValues = {
    email: "",
    password: "",
  };

  const { values, errors, handleChange, handleSubmit, touched } = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const success = await Login(
        {
          email: values.email,
          password: values.password,
        },
        next
      );

      if (success) {
        navigate(next, { replace: true });
      }
    },
  });
  return (
    <>
      <div className="w-full min-h-[100vh] py-5">
        <div className="flex justify-between items-center px-4 md:px-12">
          <Link
            to="/"
            className="flex items-center gap-1 text-[24px] font-extrabold mb-2"
          >
            <img src="/assets/logo/logo.svg" alt="" />
            <h1 className="text-[#175635]">MedTag</h1>
          </Link>
          <Link to="/contact" className="text-primary">
            Contact
          </Link>
        </div>

        <div className="flex justify-center mt-40 md:mt-40 px-4">
          <div className="flex flex-col justify-center items-center w-full px-4 md:px-0 md:w-[500px]">
            <form onSubmit={handleSubmit} className="w-full">
              <p className="font-[900] text-[22px] md:text-[30px] text-primary text-center">
                Welcome Back!
              </p>
              <p className="text-center text-gray-600 mt-3 text-sm md:text-[15px]">
                Don’t have an account?{" "}
                <Link
                  to="/sign-up"
                  className="text-primary font-semibold cursor-pointer"
                >
                  Sign up
                </Link>
              </p>
              <div className="w-full flex flex-col gap-3 mt-4">
                <div>
                  <label className="font-normal text-[14px] text-[#0B4F2C]">
                    Email Address
                  </label>
                  <input
                    type="text"
                    placeholder="Enter email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    className="w-full h-[40px] px-3 rounded-[10px] bg-[#EFEFF4] border border-[#DEE4ED] outline-none hover:border-primary focus:border-primary"
                  />
                  {errors.email && touched.email && (
                    <p className="text-red-700 text-xs mt-1">{errors.email}</p>
                  )}
                </div>
                <div>
                  <label className="font-normal text-[14px] text-[#0B4F2C]">
                    Password
                  </label>
                  <div className="relative">
                    <input
                      placeholder="Enter your password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      type={password ? "text" : "password"}
                      className="w-full h-[40px] px-3 rounded-[10px] bg-[#EFEFF4] border border-[#DEE4ED] outline-none hover:border-primary focus:border-primary"
                    />
                    <div
                      className="h-full absolute top-0 right-2 cursor-pointer flex items-center justify-center text-center"
                      onClick={() => setPassword(!password)}
                    >
                      {password ? <PiEyeSlash /> : <PiEyeLight />}
                    </div>
                  </div>
                  {errors.password && touched.password && (
                    <p className="text-red-700 text-xs mt-1">
                      {errors.password}
                    </p>
                  )}
                </div>
              </div>
              <button
                className="bg-primary hover:opacity-80 w-full h-[40px] text-white rounded-[22px] mt-6 flex justify-center items-center"
                type="submit"
                disabled={loading}
              >
                {loading ? <ButtonLoader1 /> : "Sign in"}
              </button>
            </form>
            <Link
              to="/forgot-password"
              className="text-[#0B4F2C] font-bold underline mt-2 w-full flex justify-end"
            >
              Forgot Password?
            </Link>
            <p className="font-[400] text-[15px] my-3 text-primary text-center">
              or sign in with
            </p>
            <SocialLogin />
          </div>
        </div>
      </div>
    </>
  );
}

export default Signin;
